module.exports = __webpack_public_path__ + "static/media/diagram.a521134f.png";